import BaseModelLoader from "./BaseModelLoader";
import HandlesLoader from "./cabinetLoader/HandlesLoader";
import CrownMoldingLoader from "./cabinetLoader/CrownMoldingLoader";
import SqftJsonApi from "../../../../../../api/sqftJsonApi";
import {SHAPE_LAYOUTS} from "../../../../../canvas/core/cabinet/cabinetShapes";

class CabinetLoader extends BaseModelLoader {
  constructor(opts) {
    super(opts);
    this.handlesLoader = new HandlesLoader(opts.scene, opts.loader);
    this.crownMoldingLoader = new CrownMoldingLoader(opts.scene, opts.loader, opts.modelScale);
  }

  /**
   * if cabinet was resized then we use API to resize model
   * @param data
   * @return {Promise<*>}
   */
  async getUrl(data) {
    if (data.was_resized || data.framed || data.is_filler) {

      //set points to 0 rotation
      const original_points = data.original_points;
      const contour_points = data.contour_points;
      data.original_points = data.points_on_zero_rotation.original_points;
      data.contour_points = data.points_on_zero_rotation.contour_points;

      const resized = await SqftJsonApi[
        data.shapeLayout === SHAPE_LAYOUTS.rectangle
          ? 'getResizedCabinet'
          : 'getResizedCornerCabinet'
        ](data, {});

      //restore rotated points
      data.original_points = original_points;
      data.contour_points = contour_points;
      if (resized && resized.s3Url) {
        return resized.s3Url;
      }
    }
    return data.url;
  }

  /**
   * add handles and apply material
   * @param inst
   * @param data
   * @return {Promise<void>}
   */
  async postProcess(inst, data) {
    if (data.handles && data.handles.length) {
      await this.handlesLoader.loadHandles(data, inst);
    }
    if (data.material_url) {
      const mat = this.materialCache[data.material_url];
      await this.crownMoldingLoader.loadCrownMolding(data.shapeId, mat);
    }
    inst.userData.shapeId = data.shapeId;
  }
}

export default CabinetLoader
